import './../index.css';
import SelectionStrategy from './selectionStrategy.js';
import '../collection/treeCollectionHelper.js';
import '../collection/treeCollection.js';
import './createSingleValueToggler.js';
import './createTreeCollectionToggler.js';
import './dummyToggle.js';

class ImmutableSelectionStrategy {
    strategy;
    constructor(collection, options) {
        this.strategy = new SelectionStrategy(collection, options);
    }
    /**
     * Возвращает новый набор, в котором к `items` добавлены `addedItems`.
     * @param items Текущий набор.
     * @param addedItems Добавляемые элементы.
     */
    add(items, addedItems) {
        const result = new Set(items);
        this.strategy.add(result, addedItems);
        return [...result];
    }
    /**
     * Возвращает новый набор, в котором из `items` удалены `removedItems`.
     * @param items Текущий набор.
     * @param removedItems Удаляемые элементы.
     */
    remove(items, removedItems) {
        const result = new Set(items);
        this.strategy.remove(result, removedItems);
        return [...result];
    }
}

export { ImmutableSelectionStrategy as default };
//# sourceMappingURL=immutableSelectionStrategy.js.map
